import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'additionals',
  templateUrl: './additionals.component.html',
  styleUrls: ['./additionals.component.css']
})
export class AdditionalsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
